import { FieldTemplateType } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const fieldTemplateTypeTagColorName = (type: FieldTemplateType): [string, string] => {
  switch (type) {
    case FieldTemplateType.Input:
      return ['green', 'Text'];
    case FieldTemplateType.Textarea:
      return ['yellow', 'Long text'];
    case FieldTemplateType.Select:
      return ['blue', 'Choice'];
    case FieldTemplateType.MultiSelect:
      return ['red', 'Multi Choice'];
    case FieldTemplateType.Datepicker:
      return ['orange', 'Date'];
  }
};

interface Props extends ChakraV3.TagProps {
  type: FieldTemplateType;
}

export const FieldTemplateTypeTag = (props: Props) => {
  const { type, ...rest } = props;

  const [color, name] = fieldTemplateTypeTagColorName(type);

  return (
    <ChakraV3.Tag colorPalette={color} {...rest}>
      {name}
    </ChakraV3.Tag>
  );
};
